export const apiUrl = (path) => {
  const base = process.env.REACT_APP_FORMS_API || "http://localhost:5001";
  return `${base}${path}`;
};

export const getAdminToken = () => sessionStorage.getItem("adminToken") || "";

export const setAdminToken = (token) => {
  if (token) {
    sessionStorage.setItem("adminToken", token);
  } else {
    sessionStorage.removeItem("adminToken");
  }
};

export const adminHeaders = () => ({
  Authorization: `Bearer ${getAdminToken()}`,
});
